
'use strict'

import flatpickr from "flatpickr";
import { today, isMobileRes, dateToString, stringToDate, getDaysBetweenDates, equalsArrayIgnoreOrder, sanitizeHtml} from "../utils/Utils";

const SELECTOR_DEFAULT = 0;
const SELECTOR_FROM = 1;
const SELECTOR_TO = 2;

class DateRangePickerClass{
    constructor(){
        this.main = document.getElementById('daterangepicker');

        this._isVisible = true;

        this._input = this.main.querySelector('.date_range_picker_input');
        this._actionBtn = this.main.querySelector('.action_btn');
        
        this._fromLabel = this.main.querySelector('.from_label');
        this._toLabel = this.main.querySelector('.to_label');


        this._modal = new DateRangePickerModal();
        document.body.appendChild(this._modal.main);
        
        this._minDate = null;
        this._maxDate = null;
        
        this._currentDateRange = null;
        this._daysSelected = [];
        this._currentDaysSelected = [];
        this._recurrencesDays = false;
        this.withTodayHighlighted = true;

        this._weekSelected = 0;

        this._modal.addEventListener('modalDateRangeChange', this._onModalDateRangeChange.bind(this));
    }

    set visible(value) {
        this._isVisible = value;

        if (value) {
            this.main.classList.remove('d-none');
        } else {
            this.main.classList.add('d-none');
        }
    }

    init(){
        this._minDate = today();
        this._minDate.setDate(this._minDate.getDate() + 1);
        
        this._modal.init(this._input, this._minDate, this._maxDate);
        setTimeout(() => {
            this.main.classList.add('date-range-picker--init');
        }, 1100);
    }

    show(){
        this._modal.show();
    }

    hide(){
        this._modal.hide();
    }

    addEventListener(event, callback){
        this.main.addEventListener(event, callback);
    }

    get isOpen(){
        return this._modal.isOpen;
    }

    get isOpen(){
        return this._modal.isOpen;
    }

    set dateRange(dateRange){
        
        if(dateRange.from.getTime() > dateRange.to.getTime()){
            let temp = dateRange.from;
            dateRange.from = dateRange.to;
            dateRange.to = temp;
        }
        
        
        if(dateRange.from.getTime() < this._minDate.getTime()){
            dateRange.from = this._minDate;
        }

        if(dateRange.to.getTime() < this._minDate.getTime()){
            dateRange.to = this._minDate;
        }


        if(this._maxDate != null){
            if(dateRange.from.getTime() > this._maxDate.getTime()){
                dateRange.from = this._maxDate;
            }
            
            if(dateRange.to.getTime() > this._maxDate.getTime()){
                dateRange.to = this._maxDate;
            }
        }
        

        if(this._maxDate != null && dateRange.to.getTime() > this._maxDate.getTime()){
            dateRange.to = this._maxDate;
        }
        
        this._updateLabels(dateRange);

        this._currentDateRange = dateRange;

        if(dateRange != null){
            this.main.classList.add('brand-selector--filled');
        }

        this._modal.setRange(dateRange);
    }

    get dateRange(){
        return this._currentDateRange;
    }

    get minDate(){
        return this._minDate;
    }

    get maxDate(){
        return this._maxDate;
    }

    set minDate(minDate){
        this._minDate = minDate;
        this._modal.minDate = minDate;
    }

    set maxDate(maxDate){
        this._maxDate = maxDate;
        this._modal.maxDate = maxDate;
    }

    set actionButtonSize(size = 'big'){
        this._actionBtn.classList.remove('form-input-box-actionable--size-2');
        this._actionBtn.classList.remove('form-input-box-actionable--size-3');

        switch(size){
            case 'small':
                this._actionBtn.classList.add('form-input-box-actionable--size-3');
            break;
            case 'medium':
                this._actionBtn.classList.add('form-input-box-actionable--size-2');
            break;
            case 'big':
            default:
            break;        
        }
    }

    set addClass(value = null){
        if(value && Array.isArray(value)){
            value.forEach((className)=>{
                this.main.classList.add(className);
            })
        }else{
            this.main.classList.add(value);
        }
    }
    
    set recurrencesDay(value = false){
        this._recurrencesDays = value;
        this._modal.recurrencesDay = value;
    }
    get getRecurrencesDay(){
        return this._recurrencesDays;
    }
    get getDaysSelected(){
        return this._daysSelected;
    }
    set daysSelected(value = []){
        this._daysSelected = value;
        this._modal._daysSelected = value;
        this._currentDaysSelected = value.slice();
    }
    set weekSelected(value){
        this._weekSelected = value
        this._modal._weekSelected = value;
    }

    get getWeekSelected(){
        return this._weekSelected;
    }

    set withTodayHighlighted(value = true) {
        this._withTodayHighlighted = value;
        if (this._withTodayHighlighted) {
            this._modal.main.classList.add('date-range-picker-modal--today-highlighted');
        } else {
            this._modal.main.classList.remove('date-range-picker-modal--today-highlighted');
        }
    }

    clear(){
        this._currentDateRange = null;
        this._daysSelected = [];
        this._currentDaysSelected = [];
        this._updateLabels({from: null, to: null});
        this.main.classList.remove('brand-selector--filled');
        this._modal.clear();
    }

    _onModalDateRangeChange(e){
        let dateRange = e.detail.dateRange;
        let daySelected = e.detail.daysSelected;
        
        this._updateLabels(dateRange);
        if(dateRange.from != null && dateRange.to != null  && (this._currentDateRange == null || this._currentDateRange.from.getTime() != dateRange.from.getTime() || this._currentDateRange.to.getTime() != dateRange.to.getTime())){
            this._currentDateRange = dateRange;
            this.main.dispatchEvent(new CustomEvent('dateRangeChange'));

            this.main.classList.add('brand-selector--filled');
        }    

        if (!equalsArrayIgnoreOrder(this._currentDaysSelected, daySelected)){
            this.main.dispatchEvent(new CustomEvent('selectedDayChange'));
            this._currentDaysSelected = daySelected.slice();
        }
    }

    _updateLabels(dateRange){
        this._fromLabel.innerHTML = dateRange.from != null ? dateToString(dateRange.from, 'M d Y') : 'Start date';
        this._toLabel.innerHTML = dateRange.to != null ? dateToString(dateRange.to, 'M d Y') : 'End date';
    }

}

class DateRangePickerModal{
    constructor(){
        this.main = null;

        this._initDom();
        
        this._fromBtn = this.main.querySelector('.from_btn');
        this._toBtn = this.main.querySelector('.to_btn');
        this._closeBtn = this.main.querySelector('.close_btn');

        this._isOpen = false;

        this._input = null;
        this._flatpickr = null;
        this._holderFlatpickr = this.main.querySelector('.holder_flatpickr');
        this._calendarAddonsContainer = null;
        this._applyBtnWeek = null;
        this._applyBtnSave = null;

        this._savedDates = null;
        this._prevDispatchedDates = null;
        this._prevDispatchedDays = null;
        
        this._isMobileRes = isMobileRes();

        this._currentSelector = SELECTOR_DEFAULT;

        this._minDate = null;
        this._maxDate = null;

        /*Modify Period Flow Start*/
        this._recurrencesDays = false;
        this._daysSelected = [];
        this._daysSelectedStart = [];
        /*Modify Period Flow End*/
        this._weekSelected = 0;
        this._rangeDuration = 14;

        this._fromBtn.addEventListener('click', this._onClickFromBtn.bind(this));
        this._toBtn.addEventListener('click', this._onClickToBtn.bind(this));
        this._closeBtn.addEventListener('click', this._onClickCloseBtn.bind(this));
        window.addEventListener('resize', this._onWindowResize.bind(this));

    }

    createAddonsStructure() {
        return new Promise((resolve, reject) => {
            try {
                this._calendarAddonsContainer = document.createElement("div");
                this._calendarAddonsContainer.className = "flatpickr-addons d-flex align-items-end px-3 pt-2";
                this._holderFlatpickr.querySelector('.flatpickr-calendar').appendChild(this._calendarAddonsContainer);
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }
    

    init(input, minDate, maxDate){
        this._input = input;

        this._minDate = minDate;
        this._maxDate = maxDate;

        this._initFlatpickr();
        
        this._input.addEventListener('click', this.show.bind(this));
    }

    show(){
        document.body.classList.add('daterangepicker--open');
        this._flatpickr.open();
        this.main.dispatchEvent(new CustomEvent('click'));
        if(this._recurrencesDays){
            this._paintDaysSelected();
        }
    }

    hide(){
        //document.body.classList.remove('daterangepicker--open');
        this._flatpickr.close();
    }

    addEventListener(event, callback){
        this.main.addEventListener(event, callback);
    }

    clear(){
        this._flatpickr.clear();
        this._currentSelector = SELECTOR_DEFAULT;
        this._dispatchDatesChange();
    }

    get isOpen(){
        return this._isOpen;
    }

    get minDate(){
        return this._minDate;
    }

    get maxDate(){
        return this._maxDate;
    }

    set minDate(minDate){
        this._minDate = minDate;

        this._initFlatpickr();

    }
    set recurrencesDay(value){
        this._recurrencesDays = value;

        this._initFlatpickr();
    }

    get getWeekSelected(){
        return this._weekSelected;
    }

    set maxDate(maxDate){
        this._maxDate = maxDate;

        this._initFlatpickr();
    }

    setRange(dateRange){
        this._setRange(dateRange.from, dateRange.to);
        this._prevDispatchedDates = dateRange;
    }

    _onClickFromBtn(e){
        this._setSelector(SELECTOR_FROM);
    }

    _onClickToBtn(e){
        this._setSelector(SELECTOR_TO);
    }


    _onClickCloseBtn(e){
        this.hide();
        
        if(this._savedDates != null){
            this._setRange(this._savedDates.from, this._savedDates.to);
        }else{
            this._flatpickr.clear();
        }
    }

    _initFlatpickr(){
        if(this._flatpickr != null){
            this._flatpickr.destroy();
        }
        
        
        let countMonths = !this._isMobileRes ? 2 : 1; 
        let _this = this;
        this._flatpickr = flatpickr(this._input, {
            monthSelectorType: 'static',
            yearSelectorType: 'static',
            showMonths: countMonths,
            minDate: this._minDate,
            maxDate: this._maxDate,
            nextArrow: '<i class="material-icons">keyboard_arrow_right</i>',
            prevArrow: '<i class="material-icons">keyboard_arrow_left</i>',
            mode: 'range',
            dateFormat: 'Y-m-d',
            ariaDateFormat: 'Y-m-d',
            inline: this._isMobileRes,
            appendTo: this._holderFlatpickr,
            onMonthChange: ()=>{
                if(_this._recurrencesDays) _this._paintDaysSelected();
            },
            
            onOpen: () => {
                _this._isOpen = true;

            },
            onClose: (selectedDates, dateStr, instance) => {
                _this._isOpen = false;
                
                document.body.classList.remove('daterangepicker--open');

                if(!_this._isMobileRes){
                    if(_this._savedDates != null){
                        _this._setRange(_this._savedDates.from, _this._savedDates.to);
                    }else{
                        _this._flatpickr.clear();
                    }
                    _this._dispatchDatesChange();
                }
            },
            onReady: function (selectedDates, dateStr, instance) {
                if(_this._recurrencesDays){
                    _this.createAddonsStructure().then(() => {
                        _this._addRangeButtons(instance);
                        _this._drawRecurrencesDaysUI();
                        if(_this.getWeekSelected!=0){
                            instance.calendarContainer.addEventListener("mouseleave", function () {
                                _this._resetHighlight(instance);
                            });
                        }
                    });
                }else{
                    _this._buttonsForMobile();
                }
              },
            onDayCreate: function (dObj, dStr, fp, dayElem) {
                _this._formatDay(dayElem);
                if(_this.getWeekSelected!=0){
                    dayElem.addEventListener("mouseover", function () {
                        _this._highlightRange(dayElem.dateObj, fp);
                    });
                }
            },
            onChange: function (selectedDates, dateStr, instance) {
                _this._onFlatpickrChange();
                if(_this._recurrencesDays){
                    if (selectedDates.length === 1 && _this.getWeekSelected!=0) {
                        _this._adjustEndDate(instance, selectedDates[0]);
                    }
                    _this._paintDaysSelected();
                    _this._checkDisabledDaysOfWeek();
                }
            },
            closeOnSelect: false
        });

        if(this._savedDates != null){
            this._setRange(this._savedDates.from, this._savedDates.to);
            this._highlightSelector(SELECTOR_DEFAULT);
        }else{
            this._highlightSelector(SELECTOR_FROM);
            this._currentSelector = SELECTOR_DEFAULT;
            this._updateDateLabels();
        }

        this._currentSelector = SELECTOR_DEFAULT;
        this._dispatchDatesChange();


    }

    _addRangeButtons(fp) {
        const rangeButtonContainer = document.createElement("div");
        const rangeButtonOptions = document.createElement("div");
        rangeButtonContainer.className = "flatpickr-range-buttons";
        rangeButtonOptions.className = "flatpickr-range-buttons__options pt-2";
        let label = '<p class="paragraph paragraph--size-6 color-gray-800 text-left">Period</p>';

        const button1Weeks = this._createButtonWeek("Daily", 0, fp);
        const button2Weeks = this._createButtonWeek("2 weeks", 14, fp);
        const button3Weeks = this._createButtonWeek("3 weeks", 21, fp);
        const button4Weeks = this._createButtonWeek("4 weeks", 28, fp);

        rangeButtonOptions.appendChild(button1Weeks);
        rangeButtonOptions.appendChild(button2Weeks);
        rangeButtonOptions.appendChild(button3Weeks);
        rangeButtonOptions.appendChild(button4Weeks);
        rangeButtonContainer.insertAdjacentHTML('beforeend',label);
        rangeButtonContainer.appendChild(rangeButtonOptions);

        this._calendarAddonsContainer.appendChild(rangeButtonContainer);
    }

    _createButtonWeek(label, days, fp) {
        let params = new URLSearchParams(window.location.search);
        let buttonWeekSelected = params.has('week_selected') ? params.get('week_selected') : 0;
        const button = document.createElement("button");
        let _this = this;

        button.textContent = label;
        button.className = "range-button";

        if(buttonWeekSelected==days){
            button.classList.add("active");
        }

        button.addEventListener("click", function () {
            _this._rangeDuration = days;
            _this._weekSelected = days;
            _this._resetActiveButton(fp);
            button.classList.add("active");
            if (fp.selectedDates.length > 1) {
                _this._adjustEndDate(fp, fp.selectedDates[0]); 
            }
            if (_this._recurrencesDays) {
                _this._updateDateLabels();
                _this._paintDaysSelected();
            }
        });
        return button;
    }

    _adjustEndDate(fp, startDate) {
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + Math.max(14, this._rangeDuration) - 1); 
        
        const currentMonth = fp.currentMonth;
        const currentYear = fp.currentYear;

        fp.setDate([startDate, endDate], true);
        this._resetHighlight(fp);
        fp.currentYear = currentYear;
        fp.currentMonth = currentMonth;
        fp.redraw();
    }

    _highlightRange(date, fp) {
        this._resetHighlight(fp);
        let _this = this;
        fp.calendarContainer.querySelectorAll(".flatpickr-day").forEach(function (dayElem) {
            if (dayElem.dateObj) {
                const diff = (dayElem.dateObj - date) / (1000 * 60 * 60 * 24);
                if (diff >= 0 && diff < _this._rangeDuration) {
                    dayElem.classList.add("inRangeWeek"); 
                }
            }
        });
    }

    _resetHighlight(fp) {
        fp.calendarContainer.querySelectorAll(".flatpickr-day").forEach(function (dayElem) {
            dayElem.classList.remove("inRangeWeek"); 
        });
    }

    _resetActiveButton(fp) {
        fp.calendarContainer.querySelectorAll(".range-button").forEach(function (button) {
            button.classList.remove("active"); 
        });
    }

    _setRange(from, to){
        
        if(from != null && to != null && from.getTime() > to.getTime()){
            let temp = from;
            from = to;
            to = temp;
        }

        this._flatpickr.selectedDates = [from, to];
       
        this._flatpickr.redraw();
        this._onFlatpickrChange();

    }

    _buttonsForMobile(){
        if(!this._recurrencesDays){
            this._applyBtnSave = document.createElement("a");
            this._applyBtnSave.href = "#";
            this._applyBtnSave.className = "d-flex d-md-none button button--primary button--disabled btn-mobile-apply mx-0";
            this._applyBtnSave.innerHTML = sanitizeHtml('Apply');

            this._holderFlatpickr.querySelector('.flatpickr-calendar').appendChild(this._applyBtnSave);
            this._applyBtnSave.addEventListener('click', this._onClickSaveBtn.bind(this));
        }
    }

    _drawRecurrencesDaysUI(){
        if(this._recurrencesDays){
            let params = new URLSearchParams(window.location.search);
            // dias seleccionados por URL
            let daysUrl = params.has('day_selected') ? params.get('day_selected').split(',') : [];

            this._calendarAddonsContainer.insertAdjacentHTML('beforeend', `
            <div class="flatpickr-recurrences">
                <div class="row d-flex align-items-center justify-content-between">
                    <div class="col">
                        <p class="paragraph paragraph--size-6 color-gray-800 text-left">
                            Specific set of days
                        </p>
                        <div class="recurrences-days pt-2">
                            <ul class="list-of-days">
                                <li class="${(daysUrl.indexOf("sun") !== -1?'active':'')}" data-value="sun">Sun</li>
                                <li class="${(daysUrl.indexOf("mon") !== -1?'active':'')}" data-value="mon">Mon</li>
                                <li class="${(daysUrl.indexOf("tue") !== -1?'active':'')}" data-value="tue">Tue</li>
                                <li class="${(daysUrl.indexOf("wed") !== -1?'active':'')}" data-value="wed">Wed</li>
                                <li class="${(daysUrl.indexOf("thu") !== -1?'active':'')}" data-value="thu">Thu</li>
                                <li class="${(daysUrl.indexOf("fri") !== -1?'active':'')}" data-value="fri">Fri</li>
                                <li class="${(daysUrl.indexOf("sat") !== -1?'active':'')}" data-value="sat">Sat</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            `);
            /*set vars UI*/
            this._closeBtnWeek = this._holderFlatpickr.querySelectorAll('.close_picker_btn');
            for (const close of this._closeBtnWeek) {
                close.addEventListener('click', this._onClickCloseBtn.bind(this));
            };
            this._recurrencesDaysContent = this._holderFlatpickr.querySelector('.recurrences-days');
            this._recurrencesDaysList = this._recurrencesDaysContent.querySelector('.list-of-days') != null ? this._recurrencesDaysContent.querySelector('.list-of-days') : [];

            /*Set Events*/
            for (const day of this._recurrencesDaysList.querySelectorAll('li')) {
                day.addEventListener('click', this._onClickDaysOfWeek.bind(this));
            };

            let buttonSend = `<a href="#" class="button button--size-2 button--primary button--disabled apply_picker_btn ml-auto">Apply</a>`;
            this._calendarAddonsContainer.insertAdjacentHTML('beforeend',buttonSend);
            this._applyBtnWeek = this._holderFlatpickr.querySelector('.apply_picker_btn');
            this._applyBtnWeek.addEventListener('click', this._onClickSaveBtn.bind(this));
        }
    }

    /*TODO: pasar a Utils*/

    
    _onClickCloseBtn(e){
        e.preventDefault();
        this.hide();
    }

    _resetSelectedDaysOfWeek(){
        for (const day of this._recurrencesDaysList.querySelectorAll('li')) {
            day.classList.remove("active");
        }
        this._daysSelected = [];
    }

    _checkDisabledDaysOfWeek(){
        if(this._recurrencesDaysList == undefined) return;

        for (const day of this._recurrencesDaysList.querySelectorAll('li')) {
            let daysBetween = getDaysBetweenDates( this._flatpickr.selectedDates[0], this._flatpickr.selectedDates[1], [day.dataset.value] );
            if(daysBetween.length<=0){
                day.classList.add('disabled');
            }else{
                day.classList.remove('disabled');
            }
        }
    }

    _onClickDaysOfWeek(e){
        let value = e.target.dataset.value,
        indexValue = this._daysSelected.indexOf(value);

        if(indexValue == -1){
            this._daysSelected.push(value);
            e.target.classList.add("active");
        }else{
            this._daysSelected.splice(indexValue, 1);
            e.target.classList.remove("active");
        }
        //this._dispatchDatesChange();
        this._updateDateLabels();
        this._paintDaysSelected();
    }

    _paintDaysSelected(e){
        let allDaysSelectedWeek = this._flatpickr.daysContainer.querySelectorAll(".selected--week");
        /*busco los dia del mes dentro del rango filtrando por el dia seleccioando (tue, mon, sun, etc..)*/
        let daysBetween = getDaysBetweenDates( this._flatpickr.selectedDates[0], this._flatpickr.selectedDates[1], this._daysSelected );
        /*recorro los dias del rango para resetear todas las clases*/
        allDaysSelectedWeek.forEach((day)=>{
            //les borro la class selected
            day.classList.remove('selected--week');
            day.classList.add('inRange');
        });
        /*si hay al menos 1 dia seleccionado*/
        if(this._daysSelected.length>=1){
            /*verifico si hay dias en el array*/
            if(daysBetween.length>=1){
                /*recorro los dias*/
                daysBetween.forEach((day)=>{
                    let nday = new Date(day);
                    /*selecciono los dias filtrados*/
                    let daysCalendarHtml = this._flatpickr.daysContainer.querySelectorAll("span[aria-label='"+dateToString(nday)+"']");
                    /*agrego y borro class*/
                    daysCalendarHtml.forEach((day)=>{
                        day.classList.add('selected--week');
                        day.classList.remove('inRange');
                    });
                });
            }
        }
    }
    /*TODO: hasta aca*/

    _formatDay(element){
        let num = element.textContent;
        element.innerHTML = /*html*/`<span class="flatpickr-day-wrapper">
                                <span class="flatpickr-day-number">${num}</span>
                                </span>`;
        
        //element.addEventListener('touchend', this._onTouchendDay.bind(this));                                
        //element.addEventListener('mousedown', this._onTouchendDay.bind(this));                                
    }

    _onWindowResize(e){
        if(!this._isMobileRes && isMobileRes()){
            this._isMobileRes = true;
            this._initFlatpickr(); 
        }

        if(this._isMobileRes && !isMobileRes()){
            this._isMobileRes = false;
            this._initFlatpickr();
        }
    }

    _onFlatpickrChange(e){
        this._updateDateLabels();
        switch(this._flatpickr.selectedDates.length){
            case 0: 
                this._highlightSelector(SELECTOR_FROM);
                if(!this._isMobileRes){
                    this._dispatchDatesChange();
                }
                if(this._recurrencesDays) this._applyBtnWeek.classList.add('button--disabled');
                if(!this._recurrencesDays) this._applyBtnSave.classList.add('button--disabled');
            break;
            case 1: 
                this._highlightSelector(SELECTOR_TO);
                if(!this._isMobileRes){
                    this._dispatchDatesChange();
                }
                if(this._recurrencesDays) this._applyBtnWeek.classList.add('button--disabled');
                if(!this._recurrencesDays) this._applyBtnSave.classList.add('button--disabled');
            break;
            case 2:
                this._highlightSelector(null);
                if(!this._isMobileRes){
                    this._saveDates();
                    if(this._isOpen && this._recurrencesDays == false){
                        this.hide();
                    }
                }
                if(this._recurrencesDays){
                    this._checkDisabledDaysOfWeek();
                    if(this._recurrencesDaysList != undefined){
                        this._applyBtnWeek.classList.remove('button--disabled');
                    }
                }else{
                    this._applyBtnSave.classList.remove('button--disabled');
                }
            break;
        }
    }

    _updateDateLabels(){
        let selectedDates = this._flatpickr.selectedDates;
        
        if(selectedDates.length > 0){
            this._fromBtn.querySelector('.date').innerHTML = dateToString(selectedDates[0],'M d');
            this._fromBtn.classList.add('date-range-picker-modal__date-wrapper--filled');    
        }else{
            this._fromBtn.querySelector('.date').innerHTML = 'Select';
            this._fromBtn.classList.remove('date-range-picker-modal__date-wrapper--filled');
        }

        if(selectedDates.length == 2){
            this._toBtn.querySelector('.date').innerHTML = dateToString(selectedDates[1],'M d');
            this._toBtn.classList.add('date-range-picker-modal__date-wrapper--filled');    
        }else{
            this._toBtn.querySelector('.date').innerHTML = 'Select';
            this._toBtn.classList.remove('date-range-picker-modal__date-wrapper--filled');
        }
    }

    _dispatchDatesChange(){
        let selectedDates = this._flatpickr.selectedDates;
        let selectedDay = this._daysSelectedStart;
        
        let dateRange = {
            from: selectedDates.length > 0 ? this._flatpickr.selectedDates[0] : null,
            to: selectedDates.length == 2 ? this._flatpickr.selectedDates[1] : null
        }
        // Dispatch solo si es distinto a lo que mandó por última vez
        let prevFrom = this._prevDispatchedDates == null ? null : this._prevDispatchedDates.from;
        let prevTo = this._prevDispatchedDates == null ? null : this._prevDispatchedDates.to;
        let operatorSelectedDay = (this._recurrencesDays?equalsArrayIgnoreOrder(selectedDay,this._daysSelected)==false:1==0);
        
        if(prevFrom != dateRange.from || prevTo != dateRange.to || operatorSelectedDay){
            this._prevDispatchedDates = dateRange;
            let event = new CustomEvent('modalDateRangeChange', {detail: {dateRange: dateRange, daysSelected: this._daysSelected}});
            this.main.dispatchEvent(event);
        }
    }

    _onClickSaveBtn(e){
        e.preventDefault();

        if(this._flatpickr.selectedDates.length == 2){
            this._saveDates();
            this._dispatchDatesChange();
            this.hide();
        }        
    }

    _saveDates(){
        let selectedDates = this._flatpickr.selectedDates;
        
        if(selectedDates.length == 2){
            this._savedDates = {from: this._flatpickr.selectedDates[0], to: this._flatpickr.selectedDates[1]};
        }
    }

    _onTouchendDay(e){
        if(this._currentSelector != SELECTOR_DEFAULT){
            e.preventDefault();
            e.stopPropagation();
            
            let from, to;

            switch(this._currentSelector){
                case SELECTOR_FROM:
                    from = stringToDate(e.currentTarget.getAttribute('aria-label'), 'Y-m-d');
                    to = this._flatpickr.selectedDates[1]
                break;
                case SELECTOR_TO:
                    from = this._flatpickr.selectedDates[0],'M d';
                    to = stringToDate(e.currentTarget.getAttribute('aria-label'), 'Y-m-d');
                break;
                       
            }
            
            this._setRange(from, to);
            this._setSelector(SELECTOR_DEFAULT);
        }
        
        
    }

    _setSelector(selector){
        if(selector == SELECTOR_DEFAULT || this._flatpickr.selectedDates.length == 2){
            this._currentSelector = selector;
            this._highlightSelector(this._currentSelector);
        }
    }

    _highlightSelector(selector){
        switch(selector){
            case SELECTOR_FROM:
                this._fromBtn.classList.add('date-range-picker-modal__date-wrapper--active');
                this._toBtn.classList.remove('date-range-picker-modal__date-wrapper--active');
            break;
            case SELECTOR_TO:
                this._fromBtn.classList.remove('date-range-picker-modal__date-wrapper--active');
                this._toBtn.classList.add('date-range-picker-modal__date-wrapper--active');
            break;
            default:
                this._fromBtn.classList.remove('date-range-picker-modal__date-wrapper--active');
                this._toBtn.classList.remove('date-range-picker-modal__date-wrapper--active');
            break;       
        }
    }

    _initDom(){
        let html = /*html*/`<div class="date-range-picker-modal date-range-picker-modal--flatpickr-custom">
            <div class="date-range-picker-modal__header">
            <div class="row no-gutters align-items-center">
                <div class="col">
                <!-- date-range-picker-modal__date-wrapper--active -->
                <div class="date-range-picker-modal__date-wrapper mr-1 from_btn">
                    <div>
                    <div class="date-range-picker-modal__date-label">Start date</div>
                    <div class="date-range-picker-modal__date date">&nbsp;</div>
                    </div>
                </div>
                </div>
                <div class="col">
                <div class="date-range-picker-modal__date-wrapper ml-1 to_btn">
                    <div>
                    <div class="date-range-picker-modal__date-label">End date</div>
                    <div class="date-range-picker-modal__date date">&nbsp;</div>
                    </div>
                </div>
                </div>
                <div class="col-auto">
                <div class="date-range-picker-modal__close close_btn">
                    <div class="button-close button-close--color-black"></div>
                </div>
                </div>
            </div>
            </div>
            <div class="date-range-picker-modal__calendars holder_flatpickr"></div>
        </div>`;

        this.main = document.createElement('div');
        this.main.innerHTML = html;
        this.main = this.main.firstChild;
    }
}

const DateRangePicker = new DateRangePickerClass();

if(document.readyState === 'loading'){
    document.addEventListener("DOMContentLoaded", init);
}else{
    init();
}

function init(){
    DateRangePicker.init();
    Object.seal(DateRangePicker);
}

export default DateRangePicker;